/** @fileoverview Confirms deletion of a Fabrik app. */

import { TriangleAlert } from 'lucide-react';

import type { FabrikAppSummary } from '../../types/apps';
import { Alert, AlertDescription } from '../ui/alert';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

type Props = {
  app: FabrikAppSummary | null;
  deleting: boolean;
  error: string;
  onClose: () => void;
  onDelete: () => void;
};

export default function DeleteAppDialog({ app, deleting, error, onClose, onDelete }: Props) {
  return (
    <Dialog open={Boolean(app)} onOpenChange={(open) => !open && !deleting && onClose()}>
      <DialogContent showCloseButton={!deleting}>
        <DialogHeader>
          <DialogTitle>Delete “{app?.name}”?</DialogTitle>
          <DialogDescription>
            The app and all of its chats and data will be deleted.
          </DialogDescription>
        </DialogHeader>
        <Alert variant="destructive">
          <TriangleAlert aria-hidden="true" />
          <AlertDescription>This cannot be undone.</AlertDescription>
        </Alert>
        {error && (
          <p className="text-sm text-destructive" role="alert">
            {error}
          </p>
        )}
        <DialogFooter className="-mx-4 -mb-4">
          <Button type="button" variant="outline" disabled={deleting} onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" disabled={deleting} onClick={onDelete}>
            {deleting ? 'Deleting…' : 'Delete app'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
